/**
 * Layout transformation utilities for responsive grid layouts
 */

export const sortLayoutByY = (layout: any) => {
  return layout.sort((a: any, b: any) => {
    if (a.y !== b.y) {
      return a.y - b.y;
    }
    return a.x - b.x;
  });
};

/**
 * Transform LG layout (12 columns) to XXS layout (1 column)
 * This function sorts items by Y position, then by X position for same Y values,
 * and stacks side-by-side items vertically in the single-column layout
 *
 * @param layout - The layout object containing lg property with array of layout items
 * @returns Transformed layout array for XXS breakpoint
 */
export const transformLgToXxs = (layout: any) => {
  if (!layout.lg || !Array.isArray(layout.lg)) {
    return [];
  }

  // Step 1: Sort by Y value in ascending order, then by X value for same Y
  const sortedLayout = sortLayoutByY(layout.lg);

  // Step 2: Transform to XXS layout (1 column)
  const transformedLayout = [];
  let currentY = 0;

  for (let i = 0; i < sortedLayout.length; i++) {
    const item = sortedLayout[i];
    const prevItem = i > 0 ? sortedLayout[i - 1] : null;

    if (prevItem) {
      currentY += prevItem.h;
    } else {
      currentY = item.y;
    }

    transformedLayout.push({
      ...item,
      x: 0, // Always 0 for single column
      y: currentY, // Stack vertically
      w: 1, // Full width in single column
      h: item.h, // Keep original height
    });
  }

  return transformedLayout;
};
